module.exports = __webpack_public_path__ + "static/media/send.82dbdaba.svg";